import React, { useEffect, useMemo, useState } from "react";
import EditorDashboardWrapper from "../../../layout/wrapper/EditorDashboardWrapper";
import {
  Box,
  List,
  ListItem,
  Stack,
  Tab,
  Tabs,
  Typography,
  alpha,
  styled,
} from "@mui/material";
import styles from "../../../styles/pages/user/editordashboard/editor-dashboard.module.scss";
import PendingPublicationIcon from "../../../public/assets/icons/PendingPublicationIcon";
import PublishedVideoIcon from "../../../public/assets/icons/PublishedVideoIcon";
import OpenMessageIcon from "../../../public/assets/icons/OpenMessageIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditorDashboardTable from "../../../components/Error/EditorDashboardTable/EditorDashboardTable";
import CalenderIcon from "../../../public/assets/icons/CalenderIcon";
import {
  editorsubmissionsmutation,
  totalvideoListEditorDashboard,
} from "../../../api/functions/editorDashboard.api";
import InfiniteScroll from "react-infinite-scroll-component";
import { useInfiniteQuery, useQuery } from "react-query";
import {
  emptyHandleTwo,
  getDateApiFormat,
} from "../../../lib/functions/utils.lib";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import UserCalenderDate from "../../../components/UserCalenderDate/UserCalenderDate";
import { useNavigate } from "react-router";
import useCalenderFilter from "../../../hooks/useCalenderFilter";
import EditorCalanderDate from "../../../components/UserCalenderDate/EditorCalanderDate";
import EditorPendingPublicationIcon from "../../../public/assets/icons/EditorPendingPublicationIcon";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: "auto",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "&.MuiButtonBase-root": {
        color: "#000",
        fontSize: "14px",
      },
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function EditorDashboard(props) {
  const [value, setValue] = React.useState(0);
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /*************************************/

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    navigate("editor-pending-publication?urgent_posting_request=yes");
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { data, fetchNextPage, hasNextPage, refetch, isLoading, isRefetching } =
    useInfiniteQuery({
      queryKey: [
        "totalvideoListCopywritersDashboard",
        from,
        to,
        // search, status1, date
      ],
      queryFn: ({ pageParam = 1 }) => {
        return totalvideoListEditorDashboard({ pageParam, from: from, to: to });
      },
      keepPreviousData: true,
      enabled: true,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0].current_page <
          allPages[0]?.last_page
        ) {
          return allPages[allPages.length - 1 || 0].current_page + 1;
        } else {
          return undefined;
        }
      },
    });

  const processed_data = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat.data, ...item?.data] };
    });
    return dat;
  }, [data]);

  const { data: submissionList } = useQuery(
    ["editorSubmissionList", from, to],
    () => editorsubmissionsmutation({ from: from, to: to })
  );

  console.warn("form&to", from, to);

  return (
    <>
      {isLoading ? (
        <ApiLoader loading={isLoading || isRefetching} />
      ) : (
        <EditorDashboardWrapper chatbtn={true}>
          <Box className={styles.editorDashboardWrapper}>
            <Box className={styles.editorTab}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={
                    <>
                      <Box
                        className={styles.tabItem}
                        onClick={() => navigate("editor-pending-publication")}
                      >
                        <Box className={styles.tabitemImg}>
                          <EditorPendingPublicationIcon />
                        </Box>

                        <p>
                          Pending Publication{" "}
                          <span>
                            {emptyHandleTwo(
                              submissionList?.data?.submissions
                                ?.pending_publication
                            )}
                          </span>
                        </p>
                      </Box>
                    </>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    <>
                      <Box
                        className={styles.tabItem}
                        onClick={() => navigate("editor-pending-publication")}
                      >
                        <Box className={styles.tabitemImg}>
                          <PublishedVideoIcon />
                        </Box>

                        <p>
                          Published Videos{" "}
                          <span>
                            {emptyHandleTwo(
                              submissionList?.data?.submissions
                                ?.published_videos
                            )}
                          </span>
                        </p>
                      </Box>
                    </>
                  }
                  {...a11yProps(1)}
                />
                <Tab
                  label={
                    <>
                      <Box
                        className={styles.tabItem}
                        onClick={() => navigate("editor-message/messages")}
                      >
                        <Box className={styles.tabitemImg}>
                          <OpenMessageIcon />
                        </Box>

                        <p>
                          Open Messages{" "}
                          <span>
                            {emptyHandleTwo(
                              submissionList?.data?.submissions?.open_message
                            )}
                          </span>
                        </p>
                      </Box>
                    </>
                  }
                  {...a11yProps(2)}
                />
              </Tabs>
            </Box>

            <Box className={styles.copywriterBody}>
              <PerfectScrollbar>
                <CustomTabPanel value={value} index={0}>
                  <Box className={styles.copywriterTabTitling}>
                    <Box className={styles.TitlingLeft}>
                      <Box className={styles.titlingList}>
                        <Box className={styles.titlingListItem}>
                          {processed_data?.data?.length > 0 ? (
                            <Box
                              className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                            >
                              <Box className={styles.titlingListBoxHeader}>
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  flexWrap={"wrap"}
                                  justifyContent={"space-between"}
                                  className={styles.formcontrolSearch}
                                >
                                  <Typography variant="h4">
                                    Urgent Posting Requests{" "}
                                    <span>{processed_data?.total}</span>
                                  </Typography>
                                  <Button
                                    id="demo-customized-button"
                                    aria-controls={
                                      open ? "demo-customized-menu" : undefined
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                    variant="contained"
                                    disableElevation
                                    onClick={handleClick}
                                    endIcon={<KeyboardArrowDownIcon />}
                                  >
                                    See All
                                  </Button>
                                  {/*  <StyledMenu
                                    id="demo-customized-menu"
                                    MenuListProps={{
                                      "aria-labelledby":
                                        "demo-customized-button",
                                    }}
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                  >
                                    <MenuItem
                                      onClick={handleClose}
                                      disableRipple
                                    >
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      onClick={handleClose}
                                      disableRipple
                                    >
                                      Duplicate
                                    </MenuItem>
                                    <MenuItem
                                      onClick={handleClose}
                                      disableRipple
                                    >
                                      Archive
                                    </MenuItem>
                                  </StyledMenu> */}
                                </Stack>
                              </Box>
                              <Box className={styles.titlingListBoxBody}>
                                {/* <PerfectScrollbar> */}
                                <Box className={styles.titlingListBoxItemMain}>
                                  <InfiniteScroll
                                    dataLength={processed_data?.data?.length}
                                    next={fetchNextPage}
                                    height={`calc(100vh - 400px)`}
                                    hasMore={hasNextPage}
                                    loader={<h4>Loading...</h4>}
                                    className={styles.editorDashboardScroll}
                                  >
                                    <EditorDashboardTable
                                      item={processed_data?.data}
                                    />
                                  </InfiniteScroll>
                                </Box>
                                {/* </PerfectScrollbar> */}
                              </Box>
                            </Box>
                          ) : (
                            <Box
                              className={`${styles.titlingListBox} ${styles.titlingListBoxActive} ${styles.titlingListBoxNoItem}`}
                            >
                              <Box className={styles.titlingListBoxHeader}>
                                <h4>Urgent Posting Requests</h4>
                              </Box>
                              <Box className={styles.titlingListBoxBody}>
                                <p>
                                  You have no urgent posting requests at the
                                  moment.
                                </p>
                              </Box>
                            </Box>
                          )}

                          {/* <Box className={`${styles.titlingListBox} ${styles.titlingListBoxActive} ${styles.titlingListBoxNoItem}`}>
                                                  <Box className={styles.titlingListBoxHeader}>
                                                      <h4>Urgent Posting Requests</h4>
                                                  </Box>
                                                  <Box className={styles.titlingListBoxBody}>
                                                      <p>You have no urgent posting requests at the moment.</p>
                                                  </Box>
                                              </Box> */}
                        </Box>
                      </Box>
                    </Box>

                    <Box className={styles.TitlingRight}>
                      <Box className={styles.TitlingRightDate}>
                        <Box className={styles.TitlingRightDateTxt}>
                          {/*  <Typography>
                            Showing Data for <span>Today</span>
                          </Typography>
                          <Typography
                            className={styles.TitlingRightDateTxtDate}
                          >
                            (April 22, 2023)
                          </Typography> */}
                        </Box>

                        {/* <Box className={styles.TitlingRightDateImg}>
                          <Button>
                            <CalenderIcon />
                          </Button>
                        </Box> */}

                        <EditorCalanderDate setFrom={setFrom} setTo={setTo} />
                      </Box>

                      <Box className={styles.videoTitlingSummary}>
                        <Typography variant="h4">
                          Video Publishing Summary
                        </Typography>
                        <List>
                          <ListItem>
                            Pending Publication{" "}
                            <span>
                              {" "}
                              {emptyHandleTwo(
                                submissionList?.data?.submissions
                                  ?.pending_publication
                              )}
                            </span>
                          </ListItem>
                          <ListItem>
                            Published videos{" "}
                            <span>
                              {emptyHandleTwo(
                                submissionList?.data?.submissions
                                  ?.published_videos
                              )}
                            </span>
                          </ListItem>
                        </List>
                      </Box>
                    </Box>
                  </Box>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                  <Box className={styles.copywriterTabTitling}>
                    <Box className={styles.TitlingLeft}>
                      <Box className={styles.titlingList}>
                        <Box className={styles.titlingListItem}>
                          <Box
                            className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                          >
                            <Box className={styles.titlingListBoxHeader}>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                flexWrap={"wrap"}
                                justifyContent={"space-between"}
                                className={styles.formcontrolSearch}
                              >
                                <h4>
                                  Urgent Posting Requests <span>6</span>
                                </h4>
                                <Button
                                  id="demo-customized-button"
                                  aria-controls={
                                    open ? "demo-customized-menu" : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={open ? "true" : undefined}
                                  variant="contained"
                                  disableElevation
                                  onClick={handleClick}
                                  endIcon={<KeyboardArrowDownIcon />}
                                >
                                  See all
                                </Button>
                                <StyledMenu
                                  id="demo-customized-menu"
                                  MenuListProps={{
                                    "aria-labelledby": "demo-customized-button",
                                  }}
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                >
                                  <MenuItem onClick={handleClose} disableRipple>
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={handleClose} disableRipple>
                                    Duplicate
                                  </MenuItem>
                                  <MenuItem onClick={handleClose} disableRipple>
                                    Archive
                                  </MenuItem>
                                </StyledMenu>
                              </Stack>
                            </Box>
                            <Box className={styles.titlingListBoxBody}>
                              <PerfectScrollbar>
                                <Box className={styles.titlingListBoxItemMain}>
                                  <EditorDashboardTable />
                                </Box>
                              </PerfectScrollbar>
                            </Box>
                          </Box>

                          {/* <Box className={`${styles.titlingListBox} ${styles.titlingListBoxActive} ${styles.titlingListBoxNoItem}`}>
                                                  <Box className={styles.titlingListBoxHeader}>
                                                      <h4>Urgent Posting Requests</h4>
                                                  </Box>
                                                  <Box className={styles.titlingListBoxBody}>
                                                      <p>You have no urgent posting requests at the moment.</p>
                                                  </Box>
                                              </Box> */}
                        </Box>
                      </Box>
                    </Box>

                    <Box className={styles.TitlingRight}>
                      <Box className={styles.TitlingRightDate}>
                        <Box className={styles.TitlingRightDateTxt}>
                          <Typography>
                            Showing Data for <span>Today</span>
                          </Typography>
                          <Typography
                            className={styles.TitlingRightDateTxtDate}
                          >
                            (April 22, 2023)
                          </Typography>
                        </Box>

                        <Box className={styles.TitlingRightDateImg}>
                          <Button>
                            <CalenderIcon />
                          </Button>
                        </Box>
                      </Box>

                      <Box className={styles.videoTitlingSummary}>
                        <Typography variant="h4">
                          Video Publishing Summary
                        </Typography>
                        <List>
                          <ListItem>
                            Pending Publication <span>200</span>
                          </ListItem>
                          <ListItem>
                            Published videos <span>200</span>
                          </ListItem>
                        </List>
                      </Box>
                    </Box>
                  </Box>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2}>
                  <Box className={styles.copywriterTabTitling}>
                    <Box className={styles.TitlingLeft}>
                      <Box className={styles.titlingList}>
                        <Box className={styles.titlingListItem}>
                          <Box
                            className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                          >
                            <Box className={styles.titlingListBoxHeader}>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                flexWrap={"wrap"}
                                justifyContent={"space-between"}
                                className={styles.formcontrolSearch}
                              >
                                <h4>
                                  Urgent Posting Requests <span>6</span>
                                </h4>
                                <Button
                                  id="demo-customized-button"
                                  aria-controls={
                                    open ? "demo-customized-menu" : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={open ? "true" : undefined}
                                  variant="contained"
                                  disableElevation
                                  onClick={handleClick}
                                  endIcon={<KeyboardArrowDownIcon />}
                                >
                                  See all
                                </Button>
                                <StyledMenu
                                  id="demo-customized-menu"
                                  MenuListProps={{
                                    "aria-labelledby": "demo-customized-button",
                                  }}
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                >
                                  <MenuItem onClick={handleClose} disableRipple>
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={handleClose} disableRipple>
                                    Duplicate
                                  </MenuItem>
                                  <MenuItem onClick={handleClose} disableRipple>
                                    Archive
                                  </MenuItem>
                                </StyledMenu>
                              </Stack>
                            </Box>
                            <Box className={styles.titlingListBoxBody}>
                              <PerfectScrollbar>
                                <Box className={styles.titlingListBoxItemMain}>
                                  <EditorDashboardTable />
                                </Box>
                              </PerfectScrollbar>
                            </Box>
                          </Box>

                          {/* <Box className={`${styles.titlingListBox} ${styles.titlingListBoxActive} ${styles.titlingListBoxNoItem}`}>
                                                  <Box className={styles.titlingListBoxHeader}>
                                                      <h4>Urgent Posting Requests</h4>
                                                  </Box>
                                                  <Box className={styles.titlingListBoxBody}>
                                                      <p>You have no urgent posting requests at the moment.</p>
                                                  </Box>
                                              </Box> */}
                        </Box>
                      </Box>
                    </Box>

                    <Box className={styles.TitlingRight}>
                      <Box className={styles.TitlingRightDate}>
                        <Box className={styles.TitlingRightDateTxt}>
                          <Typography>
                            Showing Data for <span>Today</span>
                          </Typography>
                          <Typography
                            className={styles.TitlingRightDateTxtDate}
                          >
                            (April 22, 2023)
                          </Typography>
                        </Box>

                        <Box className={styles.TitlingRightDateImg}>
                          <Button>
                            <CalenderIcon />
                          </Button>
                        </Box>
                      </Box>

                      <Box className={styles.videoTitlingSummary}>
                        <Typography variant="h4">
                          Video Publishing Summary
                        </Typography>
                        <List>
                          <ListItem>
                            Pending Publication <span>200</span>
                          </ListItem>
                          <ListItem>
                            Published videos <span>200</span>
                          </ListItem>
                        </List>
                      </Box>
                    </Box>
                  </Box>
                </CustomTabPanel>
              </PerfectScrollbar>
            </Box>
          </Box>
        </EditorDashboardWrapper>
      )}
    </>
  );
}
